import * as Data from 'effect/Data';

/** Timeout configuration for async operations. */
export class Timeout extends Data.Class<{
  /** How long before an operation times out. */
  readonly general: number;
}> {}
